import { Col, Container, Row } from 'reactstrap'
import RatioImage from 'src/CommonElements/RatioImage'
import { dynamicImage } from '../../../../Service'
import LoginForm from '../Common/LoginForm'

const LoginWithTooltipContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col xl="5" >
          <RatioImage className="bg-img-cover bg-center" src={dynamicImage("login/3.jpg")} alt="loginpage" />
        </Col>
        <Col xl="7" className="p-0">
          <LoginForm alignLogo="text-start" />
        </Col>
      </Row>
    </Container>
  )
}

export default LoginWithTooltipContainer